export default __webpack_public_path__ + "static/knowledge-base-0601326042c3ae1019e624663bff5c31.png";